import { IAnyObj } from 'constants/types/common.types'

declare global {
  interface Window {
    Ya: IAnyObj
    yaRef: any
  }
}

const CONTROLS_SHOW_TIME = 5000
const CONTROLS_FIRST_SHOW_TIME = 5000

enum PlayerEvent {
  STATUS_CHANGE = 'StatusChange',
  ERROR_CHANGE = 'ErrorChange',
}

export { CONTROLS_SHOW_TIME, CONTROLS_FIRST_SHOW_TIME, PlayerEvent }
